import { render } from "./inviteModal.vue?vue&type=template&id=adea1c9c&scoped=true"
import script from "./inviteModal.vue?vue&type=script&lang=js"
export * from "./inviteModal.vue?vue&type=script&lang=js"

import "./inviteModal.vue?vue&type=style&index=0&id=adea1c9c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adea1c9c"]])

export default __exports__